export enum ChangeState {
    KEEP = 'KEEP',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    CREATE = 'CREATE',
    INVALID = 'INVALID'
}
